"use strict";
/**
 * Config Module
 * @module config
 * @author cdfsunrise
 * @tip 如果所有服务，均接入api-gateway，所有业务组域名，记得全部删除
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeployEnv = exports.isMiniApp = exports.getEnv = exports.getCdnDomain = exports.getCmsSourceDomain = exports.CMS_SOURCE_DOMAINS = exports.CDN_DOMAINS = exports.ENV_TYPE = exports.gatewayPrefixGroup = exports.apiPathPrefixGroup = exports.ENVS = void 0;
exports.ENVS = ['dev', 'qa', 'pre', 'alpha', 'demo', 'prod'];
exports.apiPathPrefixGroup = {
    //
    gwApi: "",
    commonApi: "",
    dataSupportApi: "",
    dataServiceApi: "",
    promotionApi: "",
    promotionBackendApi: "",
    orderApi: "",
    orderPaymentApi: "",
    accountApi: "",
    goodsApi: "",
    stocksManagementApi: "",
    nodeServerApi: "",
    resourceGenerateApi: "",
    taskServerApi: "",
    gatewayAccountApi: "",
    restApi: "/restapi",
    restfulApi: "/restfulapi",
};
exports.gatewayPrefixGroup = {
    // 应用内网
    inner: {
        dev: 'http://g-dev.rs.net',
        qa: 'http://g-qa.rs.net',
        pre: 'http://g-pre.rs.net',
        alpha: 'http://g-alpha.rs.net',
        demo: 'http://g-demo.rs.net',
        prod: 'http://g-prod.rs.net',
    },
    // 办公网
    office: {
        dev: 'https://g-dev.cdfsunriseonline.com',
        qa: 'https://g-qa.cdfsunriseonline.com',
        pre: 'https://g-pre.cdfsunriseonline.com',
        alpha: 'https://g-alpha.cdfsunriseonline.com',
        demo: 'https://g-demo.cdfsunriseonline.com',
        prod: 'https://g-prod.cdfsunriseonline.com',
    },
    // 前端UI层调用
    outer: {
        dev: 'https://api-dev.cdfsunrise.com',
        qa: 'https://api-qa.cdfsunrise.com',
        pre: 'https://api-pre.cdfsunrise.com',
        alpha: 'https://api-alpha.cdfsunrise.com',
        demo: 'https://api-demo.cdfsunrise.com',
        prod: 'https://api.cdfsunrise.com',
    },
};
exports.ENV_TYPE = {
    WEAPP: 'WEAPP',
    SWAN: 'SWAN',
    ALIPAY: 'ALIPAY',
    TT: 'TT',
    WEB: 'WEB',
    RN: 'RN',
};
exports.CDN_DOMAINS = {
    dev: 'https://lefox-data-library-cdn-dev.cdfsunrise.com',
    alpha: 'https://lefox-data-library-cdn-alpha.cdfsunrise.com',
    qa: 'https://lefox-data-library-cdn-qa.cdfsunrise.com',
    pre: 'https://lefox-data-library-cdn-pre.cdfsunrise.com',
    demo: 'https://lefox-data-library-cdn-demo.cdfsunrise.com',
    prod: 'https://lefox-data-library-cdn.cdfsunrise.com',
};
exports.CMS_SOURCE_DOMAINS = {
    dev: 'https://data-library-cdn-dev.cdfsunrise.com',
    alpha: 'https://data-library-cdn-alpha.cdfsunrise.com',
    qa: 'https://data-library-cdn-qa.cdfsunrise.com',
    pre: 'https://data-library-cdn-pre.cdfsunrise.com',
    demo: 'https://data-library-cdn-demo.cdfsunrise.com',
    prod: 'https://data-library-cdn.cdfsunrise.com',
};
function getCmsSourceDomain() {
    return exports.CMS_SOURCE_DOMAINS[(0, exports.getDeployEnv)()];
}
exports.getCmsSourceDomain = getCmsSourceDomain;
function getCdnDomain() {
    return exports.CDN_DOMAINS[(0, exports.getDeployEnv)()];
}
exports.getCdnDomain = getCdnDomain;
/**
 * 获取小程序环境
 * @returns ENV_TYPE
 */
function getEnv() {
    if (typeof wx !== 'undefined' && wx.getSystemInfo) {
        return exports.ENV_TYPE.WEAPP;
    }
    if (typeof swan !== 'undefined' && swan.getSystemInfo) {
        return exports.ENV_TYPE.SWAN;
    }
    if (typeof my !== 'undefined' && my.getSystemInfo) {
        return exports.ENV_TYPE.ALIPAY;
    }
    if (typeof tt !== 'undefined' && tt.getSystemInfo) {
        return exports.ENV_TYPE.TT;
    }
    if (typeof global !== 'undefined' && global.__fbGenNativeModule) {
        return exports.ENV_TYPE.RN;
    }
    if (typeof window !== 'undefined') {
        return exports.ENV_TYPE.WEB;
    }
    return 'Unknown environment';
}
exports.getEnv = getEnv;
/**
 * isMiniApp
 * @returns boolean
 */
function isMiniApp() {
    if (getEnv() === exports.ENV_TYPE.WEAPP || getEnv() === exports.ENV_TYPE.SWAN || getEnv() === exports.ENV_TYPE.ALIPAY || getEnv() === exports.ENV_TYPE.TT) {
        return true;
    }
    return false;
}
exports.isMiniApp = isMiniApp;
/**
 * 获取部署环境
 * @returns DEPLOY_ENV
 */
var getDeployEnv = function (myDeployEnv) {
    ///  modify@2022-5-9
    if (myDeployEnv) {
        return myDeployEnv;
    }
    // globalThis.DEPLOY_ENV 兼容程度一般
    var myEnv = process.env.DEPLOY_ENV;
    if (myEnv) {
        return myEnv;
    }
    var env = getEnv();
    if (env === exports.ENV_TYPE.WEB) {
        if (typeof document !== 'undefined') {
            if (window.DEPLOY_ENV) {
                return window.DEPLOY_ENV;
            }
            var env_1 = exports.ENVS.find(function (item) { return window.location.href.includes('-' + item); });
            if (env_1) {
                return env_1;
            }
        }
    }
    return 'prod';
};
exports.getDeployEnv = getDeployEnv;
//# sourceMappingURL=index.js.map